import $ from 'jquery';

export function onClick(selector, callback) {
    $(selector).each(function () {
        this.addEventListener('click', callback);
    });
}

export function copyToClipboard(value) {
    let textArea = document.createElement("textarea");

    textArea.value = value;
    textArea.style.position = "fixed";  //avoid scrolling to bottom

    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    try {
        let msg = document.execCommand('copy') ? 'successful' : 'unsuccessful';

        console.log('Copying was ' + msg);
    } catch (err) {
        console.error('Unable to copy', err);
    }

    document.body.removeChild(textArea);
}

export function normalize(index, max) {
    return ((index % max) + max) % max;
}

export function createSVGElement(type, attributes) {
    let element = document.createElementNS("http://www.w3.org/2000/svg", type);

    Object.keys(attributes).forEach(function (key) {
        element.setAttribute(key, attributes[key]);
    });

    return element;
}

export function isMobile() {
    return $(window).width() < 992
        && !(!!window.MSInputMethodContext && !!document.documentMode);
}

export function isIe() {
    return !!window.MSInputMethodContext && !!document.documentMode; // IE detection
}
